import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'notifications-header-menu',
  imports: [
    MatMenuModule,
    MatMenuTrigger,
    MatIconModule,
    CommonModule,
    MatDividerModule,
    MatTooltipModule
  ],
  templateUrl: './notifications-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationsMenuComponent {
    @Output() markAllRead = new EventEmitter<void>();
    @Output() clearAll = new EventEmitter<void>();

    constructor(public router: Router)
    {}

    triggerMarkAllRead() {
        this.markAllRead.emit();
    }

    triggerClearAll() {
        this.clearAll.emit();
    }
}
